import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-marketplace",
  "use": "icon-menu-marketplace-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-marketplace\">\n<path d=\"M1.75 5.33887H14.25L15.5 15.9639H0.5L1.75 5.33887ZM4.25 9.71387H5.5V7.21387H4.25V9.71387ZM10.5 9.71387H11.75V7.21387H10.5V9.71387ZM5.5 4.08887H4.25C4.27625 3.02095 4.64083 2.13553 5.34375 1.43262C6.04667 0.729701 6.93208 0.365117 8 0.338867C9.06792 0.365117 9.95333 0.729701 10.6562 1.43262C11.3592 2.13553 11.7238 3.02095 11.75 4.08887H10.5C10.4871 3.38553 10.2429 2.79637 9.7675 2.32137C9.29208 1.84637 8.70292 1.6022 8 1.58887C7.29667 1.60178 6.7075 1.84595 6.2325 2.32137C5.7575 2.79678 5.51333 3.38595 5.5 4.08887Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-marketplace.svg
// module id = VEda
// module chunks = 258